
// @ts-nocheck

import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
    getMutationFunction,
    handleFormSubmission,
    mergeAllDataIntoFormData,
    usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {

    EDIT_DRIVER_ACCOUNT,
    GET_EMTDRIVERACCOUNT_BYID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import { useGetPageData } from "../../../custom_hooks/useGetPageData";
import { Confirm } from "../../Confirmation/Confirm";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import ".././FormComponent.scss";

import { useModalContext } from "../../Reactportal/ModalContext";

import { DriverAccountConfig, DriverAccountForMerge } from "./AddEMTDriverAccounts.config";

const AddEMTDriverAccount = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
    const { pushModal, popModal } = useModalContext();
    const [isFirstLoad, setFirstLoad] = useState(false);
    const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Driver Account");
    const [field, setFields] = useState(TypeOfPortal === "Merge" ? DriverAccountForMerge : DriverAccountConfig);
    const [selectedRows, setSelectedRows] = useState([]);
    const [ConfirmMerge, SetConfirmMerge] = useState(false);
    const [toggle, settoggle] = useState(show ? show : false);
    const [alldata, setalldata] = useState({});
    const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
    const fielddata = fielddataRedux?.EMT_Driver_Account?.Selected_Row;
    console.log(fielddata)
    const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(GET_EMTDRIVERACCOUNT_BYID, {
        fetchPolicy: "network-only",
        context: {
            headers: { "X-GraphQL-Server": "secondary" },
        },
    });
    const [allFieldsData, setAllFieldsData] = useState({});
    const { fields } = useGetPageData();

    const [EditingData, { loading: editDriverAccountLoading }] = useMutation(EDIT_DRIVER_ACCOUNT);
    //Form_Key is used to get data from the redux store
    const Form_Key = "EMT_Driver_Account";
    const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);

    const [formErrors, setFormErrors] = useState({});
    const dispatch = useDispatch();
    const DriverAccountLoadingState =
        editDriverAccountLoading || GetDataByIDLoader;

        useEffect(() => {
            pushModal(Form_Key);
            return () => {
              popModal(Form_Key)
            }
          }, []);

    useEffect(() => {
        const input = document.getElementsByName("Name");
        if (input.length > 0 && !TypeOfPortal?.includes("View")) {
            input[input.length - 1].focus();
        }
    }, []);

    useEffect(() => {
        if (FormDataFromRedux && FormDataFromRedux.hasOwnProperty(Form_Key)) {
            setalldata(FormDataFromRedux[Form_Key]);
        }
    }, [FormDataFromRedux]);

    // Handle errors received from FormInputSectionComponent
    const handleErrorsChange = (newErrors) => {
        setFormErrors((currentErrors) => ({
            ...currentErrors,
            ...newErrors,
        }));
    };
    //to check errors and throw the error submit will not
    const Validate_handleSubmit = (submit) => {
        const Error = checkFormErrors(formErrors);
        if (!Error) {
            submit();
        }
    };

    useEffect(() => {
        if (TypeOfPortal !== "Add"&& TypeOfPortal !== "Delete") {
            GetDataByID({
                variables: {
                    id: fielddata?._id,
                },
            }).then(({ data }) => {
                setAllFieldsData(data?.getDriverMasterById);
            });
        } else {
            setAllFieldsData({});
        }
    }, [fielddata]);

    useEffect(() => {
        setSelectedRows(fielddataRedux?.Driver_Account?.Selected_Rows);
    }, [fielddataRedux]);

    useEffect(() => {
        if (show === true) {
            settoggle(true);
        }
    }, [show]);

    // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
    const { executeOperation } = useSubmitOperation();
    const operationType = TypeOfPortal;
    let formData = mergeAllDataIntoFormData(alldata);
    if (operationType === "Merge") {
        formData.existingId = fielddata._id;
        formData.newId = FormDataFromRedux?.MasterData[Form_Key]?.replace_with?._id;
    }
    const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData);
    const mutationFunctions = {

        EditingData,

    };
    const PageName = "Driver Account";
    const submit = async (closeAction) => {
        if (operationType !== "Delete") {
            // Ensure Aadhar_Number is treated as a string
            if (formData.Aadhar_Number && typeof formData.Aadhar_Number !== "string") {
                formData.Aadhar_Number = formData.Aadhar_Number.toString();
            }
            // Apply the replace operation to remove non-numeric characters if Aadhar_Number exists
            if (formData.Aadhar_Number) {
                formData.Aadhar_Number = formData.Aadhar_Number.replace(/[^0-9]/g, "");
            }
            // Perform Aadhar validation if Aadhar_Number exists and operation is not deletion
            // if (formData.Aadhar_Number && !isValidAadhar(formData.Aadhar_Number)) {
            //   ErrorToast("Invalid Aadhar Number. Please check and try again.");
            //   return; // Stop the submission process if Aadhar is invalid
            // }
        }
        const mutationFunction = getMutationFunction(operationType, mutationFunctions);
        const executeOperationFunction = () =>
            executeOperation({
                operationType,
                data: formData,
                selectedRows,
                Mutation: () => mutationFunction({ variables }),
                processDataBeforeSubmit: (data) => data,
                EditRefresh: false,
                PageName: Form_Key,
            });
        handleFormSubmission(executeOperationFunction, {
            dispatch,
            operationType,
            closeAction,
            closeFormFunction: Closeformfunction,
            resetFormDataFunction: setAllFieldsData,
            onSuccess: () => { },
            onError: (error) => {
                ErrorToast(error.message);
            },
        });
    };
    const Closeformfunction = () => {
      
        ParentPortalCloseFunction();
        settoggle(false);
        setAllFieldsData({});
        dispatch({ type: "ClearData", payload: { data: {} } });
    };

    const SaveAndCloseForAdd = () => {
        submit("Close");
    };
    const ConfirmModalOpen = () => {
        SetConfirmMerge(true);
    };

    const footerContent = (
        <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={() => Validate_handleSubmit(SaveAndCloseForAdd)}
            submitType={submitType}
            SaveAndClose={
                TypeOfPortal === "Add"
                    ? () => Validate_handleSubmit(SaveAndCloseForAdd)
                    : TypeOfPortal === "Merge"
                        ? ConfirmModalOpen
                        : () => Validate_handleSubmit(submit)
            }
            handleformclose={() => {
                settoggle(!toggle);
            }}
            loadingState={DriverAccountLoadingState}
        />
    );
    return (
        <>
            <div>
                <Reactportal
                    FoooterContent={footerContent}
                    open={toggle}
                    onClose={Closeformfunction}
                    TypeOfPortal={modifiedTypeOfPortal}
                    id={""}
                >
                    {DriverAccountLoadingState && <div className="loader-line-div" />}
                    <div className="formContainer">
                        {field &&
                            field.map((e) => {
                                return (
                                    <>
                                        <div className="FormSectionParent">
                                            <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                                            <div className="FormSection twosectionsinsidecontainer">
                                                <FormInputSectionComponent
                                                    inputfields={e.fields}
                                                    Type={e.name}
                                                    fielddata={allFieldsData}
                                                    onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                                                    formkey={Form_Key}
                                                    setFirstLoad={setFirstLoad}
                                                />
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                    </div>
                </Reactportal>
            </div>
            {ConfirmMerge && (
                <Confirm
                    submit={submit}
                    settoggle={SetConfirmMerge}
                    toggle={ConfirmMerge}
                    loadingState={DriverAccountLoadingState}
                    submitType={"Confirm Merge"}
                    TypeOfPortal={"Confirm"}
                />
            )}
        </>
    );
};

export default AddEMTDriverAccount;
